import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import DatasetSchemaChanges from "components/SchemaMonitor/DatasetSchemaChanges";
import * as homeReducer from "containers/Home/reducer";

class DatasetSchemaChangesContainer extends React.PureComponent {
  render() {
    const {} = this.props;
    return <DatasetSchemaChanges {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, ownProps) => {
  return {
    linkedSchemaChanges: homeReducer.getLinkedSchemaChanges(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DatasetSchemaChangesContainer);
